import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IAttendeeRegistrationListItem } from '../../../../Models/Event/IAttendeeRegistrationListItem';
import { IInvoiceItemList } from '../../../../Models/Invoice/IInvoiceList';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { InvoiceListView } from './InvoiceListView';
import * as Services from '../../../../Services/Services';
import { CommandButton, FontIcon, mergeStyles, MessageBarType, Panel, PanelType, Stack, Text, useTheme } from '@fluentui/react';
import { IInvoiceApi } from '../../../../Services/API/Invoice/IInvoiceApi';
import { IInvoiceFilter } from '../../../../Models/Invoice/IInvoiceFilter';
import { InvoiceFilterView } from './InvoiceFilterView';
import { useState } from 'react';
import { PageTitle } from '../../../PageTitle';
import { InvoiceDetail } from '../InvoiceDetail/InvoiceDetail';

interface IInvoiceListProps {
    showHeader?: boolean;
    showAddNewInvoice?: boolean;
    searchName?: boolean;
    filter?: IInvoiceFilter;
}

const defaultFilter: IInvoiceFilter = {
    year: (new Date()).getFullYear()
}

export const InvoiceList: React.FunctionComponent<IInvoiceListProps> = (props) => {

    const [invoiceItemList, setInvoiceItemList] = React.useState<IInvoiceItemList[]>([]);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [selectedInvoice, setSelectedInvoice] = React.useState<number>(0)
    const [filter, setFilter] = React.useState<IInvoiceFilter | undefined>(props.filter ? props.filter : defaultFilter);
    const [isDetailOpened, setIsDetailOpened] = useBoolean(false)


    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const invoiceApi = Services.ServicesProvider.GetService<IInvoiceApi>(Services.InvoiceApi);
        const invoices = await invoiceApi.findInvoices(filter ? filter : {});

        if (invoices.isSuccess && invoices.data) {
            setStatusMessage({ message: invoices.message, type: MessageBarType.success });
            setInvoiceItemList(invoices.data);
        }
        else {
            setStatusMessage({ message: invoices.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadData();
    }, [filter])

    React.useEffect(() => {
        setFilter(props.filter ? props.filter : defaultFilter);
    }, [props.filter])


    const createNewInvoice = () => {
        setSelectedInvoice(0);
        setIsDetailOpened.setTrue();
    }

    const onSelectItem = (item: IInvoiceItemList) => {
        setSelectedInvoice(item.id);
        setIsDetailOpened.setTrue();
    } 

    return (<Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
        {props.showHeader ? <PageTitle title="Vystavené fatury" /> : null}
        <InvoiceFilterView searchName={props.searchName} filter={filter} setFilter={setFilter} />
        {props.showAddNewInvoice ? <CommandButton iconProps={{ iconName: 'Add' }} text="Vytvořit novou faturu" onClick={createNewInvoice} /> : null}
        <InvoiceListView
        items={invoiceItemList}
        isLoading={isLoading}
            selectItem={onSelectItem} />
        {isDetailOpened ?
            <InvoiceDetail refresh={loadData} invoiceId={selectedInvoice} isDetailOpened={isDetailOpened} onDismiss={setIsDetailOpened.setFalse} />
            : null}
        </Stack>)

}